import * as React from 'react';
import {useState} from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@mui/material/SvgIcon';
import { alpha } from '@mui/material/styles';
import TreeView from '@mui/lab/TreeView';
import TreeItem, { treeItemClasses } from '@mui/lab/TreeItem';
import Collapse from '@mui/material/Collapse';
import { useSpring, animated } from '@react-spring/web';

import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

//icons
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import MapIcon from '@mui/icons-material/Map';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import DiamondIcon from '@mui/icons-material/Diamond';
import AdjustIcon from '@mui/icons-material/Adjust';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import SettingsInputComponentOutlinedIcon from '@mui/icons-material/SettingsInputComponentOutlined';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import authContext from '../../context/authentication/authContex';
import nivel1Context from '../../context/nivel1Context/nivel1Context.js';
import Swal from 'sweetalert2';
import ContextualMenu from './ContextuaLMenu.js';
import activoContext from '../../context/activoContex/activoContex.js';
import nivel2Context from '../../context/nivel2Context/nivel2Context.js';
import nivel3Context from '../../context/nivel3Context/nivel3Context.js';
import nivel4Context from '../../context/nivel4Context/nivel4Context.js';
import nivel5Context from '../../context/nivel5Context/nivel5Context.js';

function TransitionComponent(props) {
    const style = useSpring({
        from: {
            opacity: 0,
            transform: 'translate3d(20px,0,0)',
        },
        to: {
            opacity: props.in ? 1 : 0,
            transform: `translate3d(${props.in ? 0 : 20}px,0,0)`,
        },
    });

    return (
        <animated.div style={style}>
            <Collapse {...props} />
        </animated.div>
    );
}

TransitionComponent.propTypes = {
    /**
     * Show the component; triggers the enter or exit states
     */
    in: PropTypes.bool,
};

const StyledTreeItem = React.forwardRef(function StyledTreeItem(props, ref) {
    const theme = useTheme();
    const {
        bgColor,
        color,
        labelIcon: LabelIcon,
        labelInfo,
        labelText,
        backgroundColor,
        colorForDarkMode,
        bgColorForDarkMode,
        type,
        brothers,
        deBaja,
        showContextualMenu = null,
        setShowContextualMenu = () => console.log("showContextualMenu"),
        ...other
    } = props;

    const styleProps = {
        '--tree-view-color': theme.palette.mode !== 'dark' ? color : colorForDarkMode,
        '--tree-view-bg-color':
            theme.palette.mode !== 'dark' ? bgColor : bgColorForDarkMode,
    };

    const handleContextMenu = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setShowContextualMenu({x: e.clientX, y: e.clientY, nodeId: props.nodeId, type, lvClicked: labelText, brothers: brothers ?? [], deBaja: !!deBaja});
    }

    React.useEffect(()=>{
        if(showContextualMenu && showContextualMenu.nodeId == props.nodeId){
            setShowContextualMenu({...showContextualMenu, brothers: brothers ?? []});
        }
    }, [brothers])

    return (
        <TreeItem
            label={
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        p: 0.5,
                        paddingLeft: type == 'Activo' ? 1 : 0.5,
                        paddingRight: type == 'Activo' ? 1 : 0.5,
                        pr: 0,
                        borderRadius: type == 'Activo' ? 10 : 0,
                        backgroundColor: type == 'Nivel1' ? '#1D4ED8' : type == 'Nivel2' ? '#2563EB' : type == 'Nivel3' ? '#3B82F6' : type == 'Nivel4' ? '#60A5FA' : type == 'Nivel5' ? '#93C5FD' : type == 'Activo' ? '#374151' : 'inherit',
                        opacity: deBaja ? 0.5 : 1
                    }}
                    draggable={true}
                >
                    <Box component={LabelIcon} color="inherit" sx={{ mr: 1 }} />
                    <Typography variant="body2" sx={{ fontWeight: 'inherit', flexGrow: 1 }}>
                        {labelText}
                    </Typography>
                    <Typography variant="caption" color="inherit">
                        {labelInfo}
                    </Typography>
                </Box>
            }
            style={styleProps}
            {...other}
            onContextMenu={(e) => handleContextMenu(e)}
            ref={ref}
            onDrag={()=>console.log("Dragging")}
            onDragStart={()=>console.log("Dragging")}
            draggable={true}
        />
    );
});




export default function CustomizedTreeView({ data, handleOnClick, showContextualMenu, setShowContextualMenu, modalToShow, setModalToShow, setTreeDataActivo, setIsHoveredBarByFlag, canClose, setCanClose}) {
    const {getValorActualFromDictionary} = React.useContext(authContext);
    const {eliminarNivel1eHijos} = React.useContext(nivel1Context)
    const {eliminarNivel2eHijos} = React.useContext(nivel2Context)
    const {eliminarNivel3eHijos} = React.useContext(nivel3Context)
    const {eliminarNivel4eHijos} = React.useContext(nivel4Context)
    const {eliminarNivel5eHijos} = React.useContext(nivel5Context)
    const {eliminarActivo, toggleDeBajaActivo} = React.useContext(activoContext);

    const [activeItemId, setActiveItemId] = useState(null);

    const handleItemClick = (item,id) => {
        setActiveItemId(id);
        handleOnClick(item);
    };

    const defineLabel = (type,defaultValue) => type == 'Activo' ? 'Activo' : type == 'System' ? 'Sistema' : type == 'Subsystem' ? 'Subsistema' : type == 'Product' ? 'Componente' : defaultValue

    const defineIcon = (type, defaultValue) => type == 'Activo' ? DiamondIcon : type == 'System' ? WysiwygIcon : type == 'Subsystem' ? AccountTreeIcon : type == 'Product' ? SettingsInputComponentOutlinedIcon : defaultValue;

    const defineValue = (type) => (['Activo','System','Subsystem'].includes(type)) ? 'name' : type == 'Product' ? 'descrp' :  (['Nivel4','Nivel5'].includes(type)) ? 'name' : 'nameNivel3'

    const handleDuplicate = () => {
        setModalToShow({action:'DUPLICAR', data:{id: showContextualMenu.nodeId, lvClicked: showContextualMenu.lvClicked, type: showContextualMenu.type}});
        setShowContextualMenu(null);
    }

    const handleDelete = () => {
        let {lvClicked, type, nodeId} = showContextualMenu;
        setShowContextualMenu(null);
        let warningMsg = type == 'Activo' ? `Eliminará ${lvClicked}. \n Está seguro?` : `Eliminará ${lvClicked} y todos sus hijos.\n Está seguro?`;
        Swal.fire({
            title:`Eliminar?`,
            text: warningMsg,
            icon:'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Sí, estoy seguro',
            cancelButtonColor: '#d33',
            cancelButtonText:'No',
            heightAuto: false,
            scrollbarPadding: false,
        })
        .then(res => {
            const onChainEnd = () => {
                setIsHoveredBarByFlag(true);
                setTimeout(()=>setCanClose(true), 500);
            };
            if(res.isConfirmed){
                switch(type){
                    case 'Activo':
                        eliminarActivo(nodeId, {}, [], 'TreeActivo')
                            .then(res => Swal.fire(res).finally(onChainEnd));
                        break;
                    case 'Nivel1':
                        eliminarNivel1eHijos(nodeId, false, 'TreeActivo')
                            .then(res => Swal.fire(res).finally(onChainEnd));
                        break;
                    case 'Nivel2':
                        eliminarNivel2eHijos(nodeId, false, 'TreeActivo')
                            .then(res => Swal.fire(res).finally(onChainEnd));
                        break;
                    case 'Nivel3':
                        eliminarNivel3eHijos(nodeId, false, 'TreeActivo')
                            .then(res => Swal.fire(res).finally(onChainEnd));
                        break;
                    case 'Nivel4':
                        eliminarNivel4eHijos(nodeId, false, 'TreeActivo')
                            .then(res => Swal.fire(res).finally(onChainEnd));
                        break;
                    case 'Nivel5':
                        eliminarNivel5eHijos(nodeId, false, 'TreeActivo')
                            .then(res => Swal.fire(res).finally(onChainEnd));
                        break;
                }
            }
            else Swal.fire({
                title:'Cancelado',
                heightAuto: false,
                scrollbarPadding: false,
            }).finally(onChainEnd);
        })
    }

    const handleDisable = () => {
        let {lvClicked, nodeId, deBaja: isCurrentlyDeBaja} = showContextualMenu;
        setShowContextualMenu(null);
        const accion = isCurrentlyDeBaja ? 'Habilitar' : 'Deshabilitar';
        let warningMsg = isCurrentlyDeBaja
            ? `Volverá a estar visible en tablero de activo, procedimientos programados, ordenes de trabajo y demás vistas.<br/>Está seguro?`
            : `Esto significa que no lo vera en tablero de activo ni vera sus procedimientos programados u ordenes de trabajo en sus respectivas vistas.<br/>Está seguro?`;
        Swal.fire({
            title:`${accion} ${lvClicked}?`,
            html: warningMsg,
            icon:'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Sí, estoy seguro',
            cancelButtonColor: '#d33',
            cancelButtonText:'No',
            heightAuto: false,
            scrollbarPadding: false,
        })
        .then(res => {
            const onChainEnd = () => {
                setIsHoveredBarByFlag(true);
                setTimeout(()=>setCanClose(true), 500);
            };
            if(res.isConfirmed){
                Swal.fire({
                    title: 'Procesando...',
                    heightAuto: false,
                    scrollbarPadding: false, 
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    didOpen: () => Swal.showLoading()
                });
                toggleDeBajaActivo(nodeId, 'TreeActivo')
                    .then(res => Swal.fire(res).finally(onChainEnd));
            }
            else Swal.fire({
                title:'Cancelado',
                heightAuto: false,
                scrollbarPadding: false,
            }).finally(onChainEnd);
        })
    }

    return (
        <TreeView
            aria-label="customized"
            defaultExpanded={['1']}
            defaultCollapseIcon={<ExpandLessIcon />}
            defaultExpandIcon={<ExpandMoreIcon />}
            sx={{ height: "90%", flexGrow: 1, maxWidth: 400, overflowY: 'auto' }}
        >

    { data?.map((item, index) => {
             
                return (
                    <StyledTreeItem
                        key={item?._id}
                        brothers={item.brothers}
                        labelText={`${getValorActualFromDictionary(defineLabel(item.type, 'Nivel 1'))}: ${item?.name}`}
                        labelIcon={defineIcon(item.type, MapIcon)}
                        labelInfo={item?.children?.length}
                        onClick={() =>(item.type == 'Activo' && handleItemClick(item,item?._id))}
                        className='tree'
                        type={item.type}
                        nodeId={`${item?._id}`}
                        showContextualMenu={showContextualMenu}
                        setShowContextualMenu={setShowContextualMenu}
                        deBaja={item.deBaja}
                    >
                        {item?.children?.map((item, index) => {
                            return (
                                <StyledTreeItem
                                    key={item?._id}
                                    brothers={item.brothers}
                                    labelText={`${getValorActualFromDictionary(defineLabel(item.type, 'Nivel 2'))}: ${item?.name}`}
                                    labelIcon={defineIcon(item.type, FmdGoodIcon)}
                                    backgroundColor={item.type == 'Activo' ? "midnightblue" : 'inherit'}
                                    onClick={() =>(item.type == 'Activo' && handleItemClick(item,item?._id))}
                                    labelInfo={item.type != 'Activo' ? item?.children?.length : '' ?? ''}
                                    type={item.type}
                                    nodeId={`${item?._id}`}
                                    showContextualMenu={showContextualMenu}
                                    setShowContextualMenu={setShowContextualMenu}
                                    deBaja={item.deBaja}
                                >

                                    {item?.children?.map((item, index) => {
                                        return (
                                            <StyledTreeItem
                                                key={item?._id}
                                                brothers={item.brothers}
                                                labelText={`${getValorActualFromDictionary(defineLabel(item.type, 'Nivel 3'))}: ${item[defineValue(item.type)]}`}
                                                labelIcon={defineIcon(item?.type, FmdGoodIcon)}
                                                backgroundColor={item.type == 'Activo' ? "midnightblue" : 'inherit'}
                                                labelInfo={item.type != 'Activo' ? item?.children?.length : '' ?? ''}
                                                onClick={() =>(item.type == 'Activo' && handleItemClick(item,item?._id))}
                                                expanded={true}
                                                type={item.type}
                                                nodeId={`${item?._id}`}
                                                showContextualMenu={showContextualMenu}
                                                setShowContextualMenu={setShowContextualMenu}
                                                deBaja={item.deBaja}
                                            >

                                            {item?.children?.map((item, index) => {
                                                return (
                                                    <StyledTreeItem
                                                        key={item?._id}
                                                        brothers={item.brothers}
                                                        labelText={`${getValorActualFromDictionary(defineLabel(item.type, 'Nivel 4'))}: ${item[defineValue(item.type)]}`}
                                                        labelIcon={defineIcon(item?.type, FmdGoodIcon)}
                                                        backgroundColor={item.type == 'Activo' ? "midnightblue" : 'inherit'}
                                                        labelInfo={item.type != 'Activo' ? item?.children?.length : '' ?? ''}
                                                        onClick={() =>(item.type == 'Activo' && handleItemClick(item,item?._id))}
                                                        expanded={true}
                                                        type={item.type}
                                                        nodeId={`${item?._id}`}
                                                        showContextualMenu={showContextualMenu}
                                                        setShowContextualMenu={setShowContextualMenu}
                                                        deBaja={item.deBaja}
                                                    >
                                            {item?.children?.map((item, index) => {
                                                return (
                                                    <StyledTreeItem
                                                        key={item?._id}
                                                        brothers={item.brothers}
                                                        labelText={`${getValorActualFromDictionary(defineLabel(item.type, 'Nivel 5'))}: ${item[defineValue(item.type)]}`}
                                                        labelIcon={defineIcon(item?.type, AdjustIcon)}
                                                        backgroundColor={item.type == 'Activo' ? "midnightblue" : 'inherit'}
                                                        labelInfo={item.type != 'Activo' ? item?.children?.length : '' ?? ''}
                                                        onClick={() =>(item.type == 'Activo' && handleItemClick(item,item?._id))}
                                                        expanded={true}
                                                        type={item.type}
                                                        nodeId={`${item?._id}`}
                                                        showContextualMenu={showContextualMenu}
                                                        setShowContextualMenu={setShowContextualMenu}
                                                        deBaja={item.deBaja}
                                                    >
                                                
                                                
                                                {item?.children?.map((item, index) => {
                                                    return (
                                                        <StyledTreeItem
                                                            key={item?._id}
                                                            brothers={item.brothers}
                                                            labelText={`${defineLabel(item.type, 'Activo')}: ${item.type == 'Activo' ? item?.codActivo : ''} ${item?.name}`}
                                                            labelIcon={defineIcon(item?.type, DiamondIcon)}
                                                            backgroundColor={item.type == 'Activo' ? "midnightblue" : 'inherit'}
                                                            onClick={() =>(item.type == 'Activo' && handleItemClick(item,item?._id))}
                                                            className={activeItemId === item?._id ? 'tree-activo' : ''}
                                                            type={item.type}
                                                            nodeId={`${item?._id}`}
                                                            showContextualMenu={showContextualMenu}
                                                            setShowContextualMenu={setShowContextualMenu}
                                                            deBaja={item.deBaja}
                                                            >
                                                        {item?.children?.map((item, index) => {
                                                            return (
                                                                <StyledTreeItem
                                                                    key={item?._id}
                                                                    nodeId={`${item?._id}`}
                                                                    labelText={`${defineLabel(item.type, 'Sistema')}: ${item[defineValue(item.type)]}`}
                                                                    labelIcon={WysiwygIcon}
                                                            >
                                                            {item?.children?.map((item, index) => {
                                                                return (
                                                                    <StyledTreeItem
                                                                        key={item?._id}
                                                                        nodeId={`${item?._id}`}
                                                                        labelText={`${defineLabel(item.type, 'Subsistema')}: ${item[defineValue(item.type)]}`}
                                                                        labelIcon={AccountTreeIcon}
                                                                        
                                                                    >
                                                                        {item?.children?.map((item, index) => {
                                                                            return (
                                                                                <StyledTreeItem
                                                                                    key={item?._id}
                                                                                    nodeId={`${item?._id}`}
                                                                                    labelText={`${defineLabel(item.type, 'Componente')}: ${item?.descrp}`}
                                                                                    labelIcon={SettingsInputComponentOutlinedIcon}
                                                                                    
                                                                                />


                                                                            )
                                                                        })

                                                                    }

                                                                    </StyledTreeItem>
                                                                )
                                                            })

                                                        }
                                                        </StyledTreeItem>
                                                                
                                                            )
                                                            })

                                                        }
                                                        </StyledTreeItem>
                                                                
                                                            )
                                                            })

                                                        }
                                                        </StyledTreeItem>
                                                    )
                                                    })

                                                }

                                                </StyledTreeItem>
                                              )
                                            })
        
                                            }
                                            </StyledTreeItem>
                                            
                                        )
                                    })

                                    }

                                </StyledTreeItem>
                            )
                        })

                        }
                    </StyledTreeItem>
                )

            })}

        {
            (showContextualMenu?.y && showContextualMenu?.x) && <ContextualMenu showContextualMenu={showContextualMenu} setShowContextualMenu={setShowContextualMenu} handleDuplicate={handleDuplicate} handleDelete={handleDelete} handleDisable={handleDisable} setTreeDataActivo={setTreeDataActivo} setIsHoveredBarByFlag={setIsHoveredBarByFlag}/>
        }

        </TreeView>
    );
}